// extracted by mini-css-extract-plugin
export var activeFilters = "_mg-2";
export var container = "_mg-0";
export var emptyState = "_mg-4";
export var list = "_mg-3";
export var toolbar = "_mg-1";